export default (data) => Boolean(data.DocumentContentType);
